import validateTime from "./validateTime";

const validateStartTime = (startTime, endTime) => {
  if (startTime >= endTime) {
    return "Start time must be before end time.";
  } else {
    return validateTime(startTime);
  }
};

export default validateStartTime;
